// Admin → Trust tab: autopilot score + fixes, booking terms, guests-asked Q&A.
import React from 'react';
import TrustAutopilotCard from './TrustAutopilotCard';
import BookingTermsCard from './BookingTermsCard';
import GuestQaManager from './GuestQaManager';

const TrustTab = ({ userRole, onOpenTab }) => (
  <div className="space-y-6" data-testid="trust-tab">
    <div>
      <h2 className="text-2xl font-bold text-slate-900">Trust</h2>
      <p className="text-sm text-slate-500 mt-1">Everything the website promises, checked against reality every night — plus the plain-language terms and the real guest questions visitors see. Public page: <a href="/trust" target="_blank" rel="noreferrer" className="underline hover:text-orange-600" data-testid="trust-public-link">/trust</a></p>
    </div>
    <TrustAutopilotCard userRole={userRole} onOpenTab={onOpenTab} />
    <BookingTermsCard userRole={userRole} />
    <GuestQaManager userRole={userRole} />
  </div>
);

export default TrustTab;
